import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuStylingOption} from '@Components/contextual-menu/components/contextual-menu-styling-option';
import {TextVerticalAlignType} from '@PosterWhiteboard/classes/text-styles.class';
import type {IconStates} from '@Components/contextual-menu/components/styling-options';
import {IconSize} from '@Components/icon-v2/icon.types';

interface ItemBaseVerticalAlignmentOptionProps {
  selectedAlignment: TextVerticalAlignType;
  onClickAlignmentOption(id: TextVerticalAlignType): void;
  showLargeIcons?: boolean;
  text?: string;
}

export function ItemBaseVerticalAlignmentOption({
  showLargeIcons = false,
  text = window.i18next.t('pmwjs_vertical_alignment'),
  ...props
}: ItemBaseVerticalAlignmentOptionProps): ReactElement<any> {
  const onClickHandler = (clickedId: TextVerticalAlignType): void => {
    props.onClickAlignmentOption(clickedId);
  };

  const getAlignmentOptionsData = (): Array<IconStates> => {
    return [
      {
        id: TextVerticalAlignType.TOP,
        icon: 'icon-vertical-top',
        iconSize: showLargeIcons ? IconSize.SIZE_ICON_24 : IconSize.SIZE_ICON_16,
        isSelected: props.selectedAlignment === TextVerticalAlignType.TOP,
      },
      {
        id: TextVerticalAlignType.CENTER,
        icon: 'icon-v-align-center',
        iconSize: showLargeIcons ? IconSize.SIZE_ICON_24 : IconSize.SIZE_ICON_16,
        isSelected: props.selectedAlignment === TextVerticalAlignType.CENTER,
      },
      {
        id: TextVerticalAlignType.BOTTOM,
        icon: 'icon-vertical-bottom',
        iconSize: showLargeIcons ? IconSize.SIZE_ICON_24 : IconSize.SIZE_ICON_16,
        isSelected: props.selectedAlignment === TextVerticalAlignType.BOTTOM,
      },
    ];
  };
  return <ContextualMenuStylingOption id="text-item-vertical-alignment-option" onClick={onClickHandler} label={text} data={getAlignmentOptionsData()} />;
}
